import { render, staticRenderFns } from "./ConsentPreferences.vue?vue&type=template&id=4c19b54c&scoped=true&"
import script from "./ConsentPreferences.vue?vue&type=script&lang=js&"
export * from "./ConsentPreferences.vue?vue&type=script&lang=js&"
import style0 from "./ConsentPreferences.vue?vue&type=style&index=0&id=4c19b54c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c19b54c",
  null
  
)

export default component.exports